import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, vModelRadio as _vModelRadio, createSlots as _createSlots, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/static/images/bl/wall-to-wall_tooltip.png'


const _hoisted_1 = ["max"]
const _hoisted_2 = { class: "gev19-infotext--grey" }
const _hoisted_3 = ["max", "data-fehlermeldung"]
const _hoisted_4 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_steps = _resolveComponent("steps")!
  const _component_ueberschrift = _resolveComponent("ueberschrift")!
  const _component_gebaeude_typ_radio = _resolveComponent("gebaeude-typ-radio")!
  const _component_titel_zelle = _resolveComponent("titel-zelle")!
  const _component_validierungs_fehler = _resolveComponent("validierungs-fehler")!
  const _component_info_box = _resolveComponent("info-box")!
  const _component_zelle = _resolveComponent("zelle")!
  const _component_zeile = _resolveComponent("zeile")!
  const _component_ja_nein_radio = _resolveComponent("ja-nein-radio")!
  const _component_modal = _resolveComponent("modal")!
  const _component_online_kein_angebot = _resolveComponent("online-kein-angebot")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_steps, {
      items: _ctx.navItems,
      active: 0
    }, null, 8, ["items"]),
    _createElementVNode("section", null, [
      _createVNode(_component_ueberschrift, { titel: "Bauvorhaben" }),
      (_ctx.piniaStore.state.isMakler)
        ? (_openBlock(), _createBlock(_component_gebaeude_typ_radio, {
            key: 0,
            fehler: _ctx.fehler,
            gebaeudetypen: _ctx.gebaeudetypen,
            required: _ctx.piniaStore.state.isMakler
          }, null, 8, ["fehler", "gebaeudetypen", "required"]))
        : _createCommentVNode("", true),
      _createVNode(_component_zeile, null, {
        default: _withCtx(() => [
          _createVNode(_component_titel_zelle, {
            "zeige-info": true,
            "info-box-id": "bausummeInfo"
          }, {
            default: _withCtx(() => _cache[18] || (_cache[18] = [
              _createTextVNode("Bausumme in €")
            ])),
            _: 1,
            __: [18]
          }),
          _createVNode(_component_zelle, null, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("input", {
                type: "number",
                onKeydown: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.erzwingeGanzzahl && _ctx.erzwingeGanzzahl(...args))),
                name: "bausumme",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.piniaStore.state.gebaeudedaten.bausumme) = $event)),
                class: "c-form-control__input",
                "data-cy": "bausumme",
                "data-checknummer": "true",
                min: "0",
                max: _ctx.maxBausumme,
                required: "",
                "aria-required": "true",
                "aria-label": "Geben Sie die Bausumme an"
              }, null, 40, _hoisted_1), [
                [
                  _vModelText,
                  _ctx.piniaStore.state.gebaeudedaten.bausumme,
                  void 0,
                  {
                    lazy: true,
                    trim: true,
                    number: true
                  }
                ]
              ]),
              _createVNode(_component_validierungs_fehler, {
                "fehler-text": _ctx.fehler.bausumme
              }, null, 8, ["fehler-text"]),
              _createVNode(_component_info_box, { id: "bausummeInfo" }, {
                default: _withCtx(() => _cache[19] || (_cache[19] = [
                  _createTextVNode("Gesamte Herstellungskosten einschließlich Mehrwertsteuer und Außenanlagen. Hinweis: Nicht zu berücksichtigen sind Gartenanlagen und Pflanzungen, Architektengebühren, Grundstückskosten und z.B. Baugeräte. ")
                ])),
                _: 1,
                __: [19]
              }),
              _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.piniaStore.state.isMakler
              ? "Versicherbar sind Baumaßnahmen aus dem Wohnungsbaubereich; der Wohnanteil muss mindestens 51% betragen; der gewerblich genutzte Gebäudeanteil darf höchstens 49% betragen."
              : "Unsere Bauherrenhaftpflichtversicherung gilt für Baumaßnahmen aus dem privaten Wohnungsbaubereich. Der gewerblich genutzte Gebäudeanteil darf höchstens 49 % betragen."), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_zeile, null, {
        default: _withCtx(() => [
          _createVNode(_component_titel_zelle, null, {
            default: _withCtx(() => _cache[20] || (_cache[20] = [
              _createTextVNode("Art des Bauvorhabens")
            ])),
            _: 1,
            __: [20]
          }),
          _createVNode(_component_zelle, null, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("select", {
                name: "artDesBauvorhabens",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.piniaStore.state.gebaeudedaten.artDesBauvorhabens) = $event)),
                "data-cy": "artDesBauvorhabens",
                class: "c-form-control-select",
                required: "",
                "aria-required": "true",
                "aria-label": "Wählen Sie die Art des Bauvorhabens"
              }, _cache[21] || (_cache[21] = [
                _createElementVNode("option", {
                  selected: "",
                  value: ""
                }, "Bitte wählen", -1),
                _createElementVNode("option", { value: "01" }, "Neubau", -1),
                _createElementVNode("option", { value: "03" }, "Umbau/Sanierung", -1)
              ]), 512), [
                [_vModelSelect, _ctx.piniaStore.state.gebaeudedaten.artDesBauvorhabens]
              ]),
              _createVNode(_component_validierungs_fehler, {
                "fehler-text": _ctx.fehler.artDesBauvorhabens,
                "reduzierter-abstand": true
              }, null, 8, ["fehler-text"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (_ctx.istUmbau)
        ? (_openBlock(), _createBlock(_component_zeile, { key: 1 }, {
            default: _withCtx(() => [
              _createVNode(_component_titel_zelle, null, {
                default: _withCtx(() => _cache[22] || (_cache[22] = [
                  _createTextVNode("Ist das Gebäude während des Umbaus durch Dritte bewohnt?")
                ])),
                _: 1,
                __: [22]
              }),
              _createVNode(_component_zelle, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ja_nein_radio, {
                    name: "durchDritteBewohnt",
                    modelValue: _ctx.piniaStore.state.gebaeudedaten.durchDritteBewohnt,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.piniaStore.state.gebaeudedaten.durchDritteBewohnt) = $event))
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_validierungs_fehler, {
                    "fehler-text": _ctx.fehler.durchDritteBewohnt
                  }, null, 8, ["fehler-text"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_zeile, null, {
        default: _withCtx(() => [
          _createVNode(_component_titel_zelle, {
            "zeige-info": true,
            "info-box-id": "wandAnWandInfo"
          }, {
            default: _withCtx(() => _cache[23] || (_cache[23] = [
              _createTextVNode("\"Wand-an-Wand\" oder Lückenbebauung")
            ])),
            _: 1,
            __: [23]
          }),
          _createVNode(_component_zelle, null, {
            default: _withCtx(() => [
              _createVNode(_component_ja_nein_radio, {
                name: "wandAnWand",
                modelValue: _ctx.piniaStore.state.gebaeudedaten.wandAnWand,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.piniaStore.state.gebaeudedaten.wandAnWand) = $event))
              }, null, 8, ["modelValue"]),
              _createVNode(_component_validierungs_fehler, {
                "fehler-text": _ctx.fehler.wandAnWand
              }, null, 8, ["fehler-text"]),
              _createVNode(_component_info_box, { id: "wandAnWandInfo" }, {
                default: _withCtx(() => _cache[24] || (_cache[24] = [
                  _createTextVNode("Es wird direkt an ein bestehendes Gebäude bzw. zwischen zwei bestehende Gebäude gebaut. "),
                  _createElementVNode("div", { class: "wand-an-wand" }, [
                    _createElementVNode("img", {
                      class: "bild",
                      src: _imports_0,
                      alt: "Grafische Darstellung Wand an Wand Bebauung"
                    })
                  ], -1)
                ])),
                _: 1,
                __: [24]
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (_ctx.piniaStore.state.gebaeudedaten.wandAnWand)
        ? (_openBlock(), _createBlock(_component_zeile, { key: 2 }, {
            default: _withCtx(() => [
              _createVNode(_component_titel_zelle, null, {
                default: _withCtx(() => _cache[25] || (_cache[25] = [
                  _createTextVNode("Gehört das bereits stehende Nachbargebäude zu Ihrem Eigentum?")
                ])),
                _: 1,
                __: [25]
              }),
              _createVNode(_component_zelle, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ja_nein_radio, {
                    name: "nachbargebaeudeImEigentum",
                    modelValue: _ctx.piniaStore.state.gebaeudedaten.nachbargebaeudeImEigentum,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.piniaStore.state.gebaeudedaten.nachbargebaeudeImEigentum) = $event))
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_validierungs_fehler, {
                    "fehler-text": _ctx.fehler.nachbargebaeudeImEigentum
                  }, null, 8, ["fehler-text"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_ueberschrift, { titel: "Antragsteller" }),
      _createVNode(_component_zeile, null, {
        default: _withCtx(() => [
          _createVNode(_component_titel_zelle, {
            "zeige-info": true,
            "info-box-id": "antragstellerInfo"
          }, {
            default: _withCtx(() => _cache[26] || (_cache[26] = [
              _createTextVNode("Antragsteller ist")
            ])),
            _: 1,
            __: [26]
          }),
          _createVNode(_component_zelle, { class: "mkRadio" }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.piniaStore.state.antragssteller) = $event)),
                type: "radio",
                id: "antragsstellerBauherr",
                name: "antragssteller",
                value: "bauherr",
                required: "",
                "aria-required": "true",
                "aria-label": "Antragssteller ist der Bauherr",
                "data-fehlermeldung": "Bitte treffen Sie eine Auswahl",
                "data-cy": "antragsstellerBauherr"
              }, null, 512), [
                [_vModelRadio, _ctx.piniaStore.state.antragssteller]
              ]),
              _cache[28] || (_cache[28] = _createElementVNode("label", {
                for: "antragsstellerBauherr",
                class: "radiolabel"
              }, "Bauherr", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.piniaStore.state.antragssteller) = $event)),
                type: "radio",
                id: "antragsstellerArchitekt",
                name: "antragssteller",
                value: "architekt",
                "aria-label": "Antragssteller ist der Architekt, Bauträger, Bauunternehmer",
                "data-cy": "antragsstellerBauherr"
              }, null, 512), [
                [_vModelRadio, _ctx.piniaStore.state.antragssteller]
              ]),
              _cache[29] || (_cache[29] = _createElementVNode("label", {
                for: "antragsstellerArchitekt",
                class: "radiolabel"
              }, "Architekt oder Bauträger", -1)),
              _createVNode(_component_validierungs_fehler, {
                "fehler-text": _ctx.fehler.antragssteller,
                "reduzierter-abstand": true
              }, null, 8, ["fehler-text"]),
              _createVNode(_component_info_box, { id: "antragstellerInfo" }, {
                default: _withCtx(() => _cache[27] || (_cache[27] = [
                  _createTextVNode("Nicht versicherbar sind Bauvorhaben, bei denen der Versicherungsnehmer Architekt, Bauträger, Bauunternehmer o. ä. ist. ")
                ])),
                _: 1,
                __: [27]
              })
            ]),
            _: 1,
            __: [28,29]
          })
        ]),
        _: 1
      }),
      (_ctx.piniaStore.state.antragssteller === 'bauherr')
        ? (_openBlock(), _createBlock(_component_zeile, { key: 3 }, {
            default: _withCtx(() => [
              _createVNode(_component_titel_zelle, {
                "zeige-info": true,
                "info-box-id": "bauleitungInfo"
              }, {
                default: _withCtx(() => _cache[30] || (_cache[30] = [
                  _createTextVNode("Ist die Planung, Bauleitung und -ausführung an Dritte vergeben ? ")
                ])),
                _: 1,
                __: [30]
              }),
              _createVNode(_component_zelle, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ja_nein_radio, {
                    name: "bauleitungDurchDritte",
                    modelValue: _ctx.piniaStore.state.bauleitungDurchDritte,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.piniaStore.state.bauleitungDurchDritte) = $event))
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_validierungs_fehler, {
                    "fehler-text": _ctx.fehler.bauleitungDurchDritte
                  }, null, 8, ["fehler-text"]),
                  _createVNode(_component_info_box, { id: "bauleitungInfo" }, {
                    default: _withCtx(() => _cache[31] || (_cache[31] = [
                      _createTextVNode("Für das Bauvorhaben muss ein externer Bauleiter oder Architekt verantwortlich sein und die Baufortschritte abnehmen. ")
                    ])),
                    _: 1,
                    __: [31]
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_ueberschrift, { titel: "Eigenbauleistung" }),
      _createVNode(_component_zeile, null, {
        default: _withCtx(() => [
          _createVNode(_component_titel_zelle, {
            "zeige-info": true,
            "info-box-id": "eigenbauleistungenInfo"
          }, {
            default: _withCtx(() => _cache[32] || (_cache[32] = [
              _createTextVNode("Werden Eigenbauleistungen erbracht? ")
            ])),
            _: 1,
            __: [32]
          }),
          _createVNode(_component_zelle, null, {
            default: _withCtx(() => [
              _createVNode(_component_ja_nein_radio, {
                name: "eigenbauleistungen",
                modelValue: _ctx.piniaStore.state.gebaeudedaten.eigenbauleistungen.erbracht,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.piniaStore.state.gebaeudedaten.eigenbauleistungen.erbracht) = $event))
              }, null, 8, ["modelValue"]),
              _createVNode(_component_validierungs_fehler, {
                "fehler-text": _ctx.fehler.eigenbauleistungen
              }, null, 8, ["fehler-text"]),
              _createVNode(_component_info_box, { id: "eigenbauleistungenInfo" }, {
                default: _withCtx(() => _cache[33] || (_cache[33] = [
                  _createTextVNode("Voraussetzung für die Wirksamkeit dieses Versicherungsschutzes ist, dass die "),
                  _createElementVNode("strong", null, "Bauarbeiten in Eigenleistungen", -1),
                  _createTextVNode(" unter der regelmäßigen Kontrolle fachlich geeigneter Personen wie z.B. Architekten oder selbstständigen Handwerksmeistern aus dem Baufach stehen. ")
                ])),
                _: 1,
                __: [33]
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (_ctx.piniaStore.state.gebaeudedaten.eigenbauleistungen.erbracht)
        ? (_openBlock(), _createBlock(_component_zeile, { key: 4 }, {
            default: _withCtx(() => [
              _createVNode(_component_titel_zelle, null, {
                default: _withCtx(() => _cache[34] || (_cache[34] = [
                  _createTextVNode("Höhe der Eigenbauleistung in €")
                ])),
                _: 1,
                __: [34]
              }),
              _createVNode(_component_zelle, null, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("input", {
                    onKeydown: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.erzwingeGanzzahl && _ctx.erzwingeGanzzahl(...args))),
                    name: "eigenbauleistungenBetrag",
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.piniaStore.state.gebaeudedaten.eigenbauleistungen.betrag) = $event)),
                    class: "c-form-control__input",
                    "data-cy": "eigenbauleistungenBetrag",
                    "data-checknummer": "true",
                    min: "1",
                    max: _ctx.maxEigenbauleistungenBetrag,
                    required: "",
                    "aria-required": "true",
                    "aria-label": "Höhe der Eigenbauleistung in Euro",
                    "data-fehlermeldung": _ctx.erlaubteEigenbauleistungenBetragUeberschritten
                  }, null, 40, _hoisted_3), [
                    [
                      _vModelText,
                      _ctx.piniaStore.state.gebaeudedaten.eigenbauleistungen.betrag,
                      void 0,
                      {
                        lazy: true,
                        trim: true,
                        number: true
                      }
                    ]
                  ]),
                  _createVNode(_component_validierungs_fehler, {
                    "fehler-text": _ctx.fehler.eigenbauleistungenBetrag
                  }, null, 8, ["fehler-text"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.piniaStore.state.gebaeudedaten.eigenbauleistungen.erbracht)
        ? (_openBlock(), _createBlock(_component_zeile, { key: 5 }, {
            default: _withCtx(() => [
              _createVNode(_component_titel_zelle, {
                "zeige-info": true,
                "info-box-id": "statikInfo"
              }, {
                default: _withCtx(() => _cache[35] || (_cache[35] = [
                  _createTextVNode("Werden durch Sie Arbeiten an der Statik durchgeführt? ")
                ])),
                _: 1,
                __: [35]
              }),
              _createVNode(_component_zelle, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ja_nein_radio, {
                    name: "eigenbauleistungenStatik",
                    modelValue: _ctx.piniaStore.state.gebaeudedaten.eigenbauleistungen.statik,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.piniaStore.state.gebaeudedaten.eigenbauleistungen.statik) = $event))
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_validierungs_fehler, {
                    "fehler-text": _ctx.fehler.eigenbauleistungenStatik
                  }, null, 8, ["fehler-text"]),
                  _createVNode(_component_info_box, { id: "statikInfo" }, {
                    default: _withCtx(() => _cache[36] || (_cache[36] = [
                      _createTextVNode("Nicht versicherbar sind in Eigenleistung durchgeführte Arbeiten zur Erstellung, dem Abtragen oder der Veränderung von statisch relevanten Bauteilen wie z.B. Fundamenten inkl. Grundbruch, an tragenden Wänden, Decken/Böden, Fenster- und Türstürzen, Unterzügen/Überzügen und Dachkonstruktion. ")
                    ])),
                    _: 1,
                    __: [36]
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_zeile, null, {
        default: _withCtx(() => [
          _createVNode(_component_zelle, {
            breite: 3,
            offset: 4
          }, {
            default: _withCtx(() => [
              _createElementVNode("button", {
                class: "c-button c-button--full-width u-mar-t-2 u-mar-b-2 mobil-mehrAbstand",
                onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args))),
                "data-cy": "submitZumVergleich",
                disabled: !_ctx.weiterMoeglich
              }, " Weiter zum Vergleich ", 8, _hoisted_4)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    (_ctx.istSichtbar('modal-antragstellerArchitekt'))
      ? (_openBlock(), _createBlock(_component_modal, {
          key: 0,
          titel: "Antragsteller ist Architekt, Bauträger, Bauunternehmer o. ä.",
          onCloseModal: _cache[14] || (_cache[14] = ($event: any) => (_ctx.wechsleSichtbarkeit('modal-antragstellerArchitekt')))
        }, _createSlots({ _: 2 }, [
          (_ctx.piniaStore.state.isMakler)
            ? {
                name: "inhalt",
                fn: _withCtx(() => [
                  _cache[37] || (_cache[37] = _createTextVNode(" Dieses Risiko ist nicht versicherbar."))
                ]),
                key: "0"
              }
            : {
                name: "inhalt",
                fn: _withCtx(() => [
                  _cache[38] || (_cache[38] = _createTextVNode(" Auf Grund ihrer Angabe können wir Ihnen leider keinen Versicherungsschutz anbieten. "))
                ]),
                key: "1"
              }
        ]), 1024))
      : _createCommentVNode("", true),
    (_ctx.istSichtbar('modal-bauleitungDurchDritte'))
      ? (_openBlock(), _createBlock(_component_modal, {
          key: 1,
          titel: "Planung, Bauleitung und -ausführung",
          onCloseModal: _cache[15] || (_cache[15] = ($event: any) => (_ctx.wechsleSichtbarkeit('modal-bauleitungDurchDritte')))
        }, {
          inhalt: _withCtx(() => [
            _createVNode(_component_online_kein_angebot)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.istSichtbar('modal-statik'))
      ? (_openBlock(), _createBlock(_component_modal, {
          key: 2,
          titel: "Arbeiten an der Statik",
          onCloseModal: _cache[16] || (_cache[16] = ($event: any) => (_ctx.wechsleSichtbarkeit('modal-statik')))
        }, {
          inhalt: _withCtx(() => [
            _createVNode(_component_online_kein_angebot)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.istSichtbar('modal-eigenbauleistung'))
      ? (_openBlock(), _createBlock(_component_modal, {
          key: 3,
          titel: "Eigenbauleistung",
          onCloseModal: _cache[17] || (_cache[17] = ($event: any) => (_ctx.wechsleSichtbarkeit('modal-eigenbauleistung')))
        }, {
          inhalt: _withCtx(() => _cache[39] || (_cache[39] = [
            _createElementVNode("strong", null, "Höhe der Eigenbauleistung in €", -1),
            _createElementVNode("br", null, null, -1),
            _createTextVNode(" Dieses Risiko ist nicht versicherbar. Die Eigenbauleistung darf maximal 50% der Bausumme betragen. ")
          ])),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}